export default "__VITE_ASSET__3Jpxuloj__"